// @flow

import { RestClientAuthenticated } from '../network';
import { turanBaseURL } from '../../utils/urlUtils';

const officeApi = {
  list: () => new RestClientAuthenticated(`${turanBaseURL()}/urw-offices`, 'GET').execute(),
  fetchOffice: (officeId: string) => new RestClientAuthenticated(`${turanBaseURL()}/urw-offices/${officeId}`, 'GET').execute(),
  fetchMedias: (officeId: string) => new RestClientAuthenticated(`${turanBaseURL()}/urw-offices/${officeId}/keepeek-medias`, 'GET').execute(),
};

export default officeApi;
